import React from 'react'
import Card from '../components/Card'
import { ReactSVG } from 'react-svg'
import Btn from '../components/Btn'
import BtnIcon from '../components/BtnIcon'
import TextField from '../components/TextField'
import { Link } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { ERROR_DICT, errorDict } from '../utils/errorDict'
import { EMAIL_VALIDATION_PATTERN } from '../constants'
import { AuthStore } from '../store/authStore'
import { ConfigStore } from '../store/configStore'
import { Vendor } from '../server/public/config/get'

function LoginPage(): JSX.Element {
  const {
    handleSubmit,
    control,
    formState: { errors }
  } = useForm()
  const [error, setError] = React.useState('')

  const onSubmit = async (data: any): Promise<void> => {
    setError('')

    const e = await AuthStore.login(data.email, data.password)

    if (e) {
      setError(e.message)
    }
  }

  return (
    <div className="auth-layout-view" style={{ maxWidth: '44rem' }}>
      <Card className="auth-layout-view__card auth-card">
        <header className="auth-card__head">
          <h1>
            Вход на{' '}
            <ReactSVG
              wrapper="span"
              className="auth-logo"
              src="/i/logo-sm.svg"
            />
          </h1>
        </header>
        <div className="auth-card__content">
          {ConfigStore.publicConfig.authorizationVendors?.length ? (
            <div
              className={
                'u-flex u-flexCol u-flexAlignItemsCenter text-align-center text-body-small mb-md-5 mb-sm-4'
              }
            >
              <p>Вход через соцсети</p>
              <div className={'mt-md-5 mt-sm-4 row row-gap-20'}>
                {ConfigStore.publicConfig.authorizationVendors.map(
                  ({ href, name, icon }: Vendor) => (
                    // <a
                    //   key={href}
                    //   title={name}
                    //   className={'authorization-vendor'}
                    //   href={href}
                    // >
                    //   <img src={icon} alt={name} />
                    // </a>
                    <Btn href={href} outlined key={href}>
                      Войти с помощью ЕТА ГУАП
                      <BtnIcon>
                        <ReactSVG src={icon}></ReactSVG>
                      </BtnIcon>
                    </Btn>
                    
                    
                  )
                )}
              </div>
              <p className={'mt-md-8 mt-sm-6'}>или электронную почту</p>
            </div>
          ) : null}
          <form onSubmit={handleSubmit(onSubmit)} className="auth-card-form">
            <div className="auth-card-form__fields">
              <TextField
                control={control}
                rules={{
                  required: true,
                  pattern: {
                    value: EMAIL_VALIDATION_PATTERN,
                    message: ERROR_DICT.email
                  }
                }}
                hasError={!!errors.email || !!error}
                errorText={
                  (errors.email?.type === 'pattern'
                    ? ERROR_DICT.email
                    : errorDict(errors.email)) || error
                }
                name="email"
                type="email"
                label="Электронная почта"
                required
              ></TextField>
              <TextField
                autocomplete={'on'}
                control={control}
                rules={{ required: true }}
                hasError={!!errors.password}
                errorText={errorDict(errors.password)}
                name="password"
                type="password"
                label="Пароль"
                required
              ></TextField>
              <Link
                className={'link text-body-small-bold'}
                to={'/auth/restore'}
              >
                Забыли пароль?
              </Link>
            </div>
            <footer className="auth-card-form__foot mt-md-8 mt-sm-6">
              <Btn
                disabled={AuthStore.isPending}
                loading={AuthStore.isPending}
                type="submit"
              >
                Войти
              </Btn>
            </footer>
          </form>
        </div>
      </Card>

      <footer className="auth-layout-view__foot">
        Нет аккаунта?{' '}
        <Link className={'link text-body-bold'} to={'/auth/sign-up'}>
          Зарегистрироваться
        </Link>
      </footer>
    </div>
  )
}

export default LoginPage
